import React, {useEffect, useState} from 'react';
import './style.scss';
import classNames from "classnames";
import PropTypes from "prop-types";
import RulesBtn from "../rulesBtn";
import Copyright from "../copyright";
import PaymentIcons from "../paymentIcons";
import SocialLinks from "../socialLinks";

/**
 * Компонент Footer
 *
 * @component
 * @param {Object} props
 * @param {Boolean} [props.hasCopyright=true] Нужно ли выводить копирайт, true - нужно, false - не нужно
 * @param {String} [props.bkString=Букмекерская_контора_Зенит] Текст для первой строчки копирайта
 * @param {String} [props.rightString=Все_права_защищены] Текст для второй строчки копирайта
 * @param {Boolean} [props.hasPayments=true] Нужно ли выводить платежки, true - нужно, false - не нужно
 * @param {Array} [props.payArray=['visa','mastercard','youmoney']] Массив названий платежек
 * @param {Boolean} props.hasRules Нужно ли выводить кнопку правил, true - нужно, false - не нужно
 * @param {Number} props.promoId id фрибета, по которому берутся правила (если есть кнопка правил, то обязательное поле)
 * @param {Number} props.langId id языка для правил
 * @param {String} [props.title=Правила] Текст кнопки правил
 * @param {Boolean} [props.hasSocialLinks] Нужно ли выводить соц сети, true - нужно, false - не нужно
 * @param {Array} [props.links=['vk','instagram']] Массив названий соц сетей
 * @param {String} [props.lang=ru] Страна для ссылок на соц сети в формате 'ru', 'br' и т.д.
 * @param {String} [props.target=blank] Параметр открытия ссылки соц сетей
 * @param {Boolean} [props.layout] Класс для контейнера
 * @param {Boolean} [props.container] Класс для контейнера
 * @param {function} [props.pictures] Картинки на заднем фоне
 * @param {JSXElement} props.children Дочерние элементы, если есть (например, кнопки "вход" / "регистрация")
 * @param {String} props.id Идентификатор для элемента footer на случай, если на странице несколько футеров с разными стилями
 * @param {String} props.className Класс для элемента footer на случай, если на странице несколько футеров с разными стилями
 *
 * @returns {JSX.Element} Возвращает требуемый компонент Footer
 */
const Footer = ({
                    hasCopyright, bkString, rightString,
                    hasPayments, payArray,
                    hasRules, promoId, langId, title,
                    hasSocialLinks, links, lang, target,
                    layout, container,
                    pictures, children, id, className
                }) => {

    const [markdown, setMarkdown] = useState('');
    useEffect(() => {
        if (!hasRules && !hasCopyright && !hasSocialLinks && hasPayments)
            setMarkdown('containerCenter')
        if (hasRules && !hasCopyright && hasSocialLinks && hasPayments)
            setMarkdown('containerOrder containerFlexBasis')
        if (!hasSocialLinks && hasPayments && hasRules && hasCopyright)
            setMarkdown('containerFlexBasis')
        if (!hasRules && !hasSocialLinks && hasPayments && hasCopyright)
            setMarkdown('containerFlexBasis')
        if (!hasRules && hasCopyright && hasPayments && hasSocialLinks)
            setMarkdown('containerFlexBasisOrder')
    }, [hasRules, hasCopyright, hasSocialLinks, hasPayments])

    const classesWrapper = classNames(
        'footer-wrapper',
        {container},
        {layout},
        markdown
    );

    return (
        <footer id={id} className={className}>
            <div className={classesWrapper}>
                {hasCopyright &&
                <Copyright
                    bkString={bkString}
                    rightString={rightString}
                />}
                {hasPayments &&
                <PaymentIcons
                    imgs={payArray}
                />}
                {hasRules &&
                <RulesBtn
                    promoId={promoId}
                    langId={langId}
                    title={title}
                    lang={lang}
                />}
                {hasSocialLinks &&
                <SocialLinks
                    links={links}
                    lang={lang}
                    target={target}
                />}
                {pictures && pictures()}
                {children}
            </div>
        </footer>
    )
}

Footer.propTypes = {
    hasRules: PropTypes.bool,
    promoId: PropTypes.number,
    langId: PropTypes.number,
    title: PropTypes.string,

    hasPayments: PropTypes.bool,
    payArray: PropTypes.array,

    hasCopyright: PropTypes.bool,
    bkString: PropTypes.string,
    rightString: PropTypes.string,

    links: PropTypes.array,
    lang: PropTypes.string,
    target: PropTypes.string,

    container: PropTypes.bool,
    layout: PropTypes.bool
}

Footer.defaultProps = {
    hasCopyright: true,
    hasPayments: true
}

export default Footer
